export const environment = {
  production: false,
  env: 'HOMO',
  apiUrl: 'https://empresas.integracion.h.redlink.com.ar/pasarela-pagos-services/api/comercio/v1',
  backendUrl: 'https://billetera-blanca.h.redlink.com.ar',
  gobiernoUrl: 'https://sir-test.dguiaf-gcba.gov.ar/'
};